import i18n from "@/i18n";
import FrequencyTrendLimitConfigurationLogService from "../../service/FrequencyTrendLimitConfigurationLogService";
import DateTimeHandlerService from "@/services/common/date-time/DateTimeHandlerService";
import {
	OPEN_DIALOG_MODIFIED_EMAILS,
	CLOSE_DIALOG_MODIFIED_EMAILS,
	SET_SEARCH,
	ON_EXPAND_TABLE,
	RESET_EXPANDED_ITEM
} from "./FrequencyTrendLimitLogActionTypes";
import { SHOW_ERROR_MESSAGE } from "../FrequencyTrendLimitConfigurationActionsType";
import {
	GET, SET, RESET_STATE
} from "@/stores/CommumActionTypes";

import { FREQUENCY_TREND_LIMIT_CONFIGURATION_PATH } from "../ModulePath";

const actions = {

	/**
   * Abre o diálogo para exibir os emails modificados.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Object} tableRow - Linha da tabela contendo os dados do limite de sinal modificados.
   */
	[OPEN_DIALOG_MODIFIED_EMAILS]: ({ commit }, tableRow) =>
	{
		commit(OPEN_DIALOG_MODIFIED_EMAILS, tableRow);
	},

	/**
   * Fecha o diálogo de emails modificados.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[CLOSE_DIALOG_MODIFIED_EMAILS]: ({ commit }) =>
	{
		commit(CLOSE_DIALOG_MODIFIED_EMAILS);
	},

	/**
   * Define os logs fornecidos e guarda na store.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Array} logs - Lista de logs.
   */
	[SET]: ({ commit }, logs) =>
	{
		commit(SET, logs);
	},

	/**
   * Busca os logs de configuração de limite de tendência de frequência na API,
	 * limitado pela empresa de quem faz a requisição.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Promise<Object>} asyncEventDateTimePicker - Uma "Promise" contendo objeto de data e hora de início e fim
	 * da pesquisa.
   */
	[GET]: async({ commit }, asyncEventDateTimePicker) =>
	{
		try
		{
			commit(GET);

			// Obtém a data e hora do seletor
			const dateTime = await asyncEventDateTimePicker;

			const startDateTime = DateTimeHandlerService.ToUTCDateTime(`${dateTime.startDate} ${dateTime.startTime}`);
			const endDateTime = DateTimeHandlerService.ToUTCDateTime(`${dateTime.endDate} ${dateTime.endTime}`);

			const logs = await FrequencyTrendLimitConfigurationLogService
				.GetFrequencyTrendLimitNotificationLogs(startDateTime, endDateTime);

			commit(RESET_EXPANDED_ITEM);

			commit(SET, logs);
		}
		catch (error)
		{
			commit(RESET_EXPANDED_ITEM);

			// Em caso de erro, define os logs como uma lista vazia.
			commit(SET, []);

			const errorMessage = i18n.t("ErrorMessages.TrendFrequencyLimitLogError");
			// Aciona o erro no pai.
			commit(`${FREQUENCY_TREND_LIMIT_CONFIGURATION_PATH}/${SHOW_ERROR_MESSAGE}`, errorMessage);
		}
	},

	/**
   * Define o que o usuário está digitando na procura da tabela.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {string} strToSearch - Entrada do usuário no formulário de busca.
   */
	[SET_SEARCH]: ({ commit }, strToSearch) =>
	{
		commit(SET_SEARCH, strToSearch);
	},

	/**
	 * Define os valores do objeto da tabela expandida e se ela está ou não expandida.
	 *
	 * @param {Object} context - O contexto Vuex.
	 * @param {Object} event - Objeto do evento de click de expansão.
	 */
	[ON_EXPAND_TABLE]: ({ commit }, event) =>
	{
		commit(ON_EXPAND_TABLE, event);
	},

	/**
   * Reseta o state desse modulo.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[RESET_STATE]: ({ commit }) =>
	{
		commit(RESET_STATE);
	},

	/**
	 * Reseta o item em expansão.
	 *
	 * @param {Object} context - O contexto Vuex.
	 */
	[RESET_EXPANDED_ITEM]: ({ commit }) =>
	{
		commit(RESET_EXPANDED_ITEM);
	},
};

export default { actions };